// import React, { useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, Badge, CardFooter, ProgressBar } from 'react-bootstrap';
// import 'react-datepicker/dist/react-datepicker.css';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { ntxAPI } from '@API/axiosNeatex';
// import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import type { APIResponse } from '@store/Shared/shared';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import { TreeSelect } from 'antd';
// import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
// import Loading from '@components/Shared/Loader/Loading';

// interface StockAging {
//   itemId: string;
//   itemCode: string;
//   itemName: string;
//   itemName2: string;
//   qty: number;
//   ageInDays: number;
//   bucket: string;
// }
// const StockAgingReport: React.FC = () => {
//   const [data, setData] = useState<StockAging[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
//   const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
//   const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
//   const { t, i18n } = useTranslation();
//   const [showZeroQuantity, setShowZeroQuantity] = useState<boolean>(false);

//   // Filter states
//   const [itemId, setItemId] = useState<string | null>('');
//   const [inventoryId, setInventoryId] = useState<string | null>('');
//   const [subInventoryId, setSubInventoryId] = useState<string | null>('');
//   const [showZeroBalance, setShowZeroBalance] = useState<boolean>(false);

//   const fetchData = async () => {
//     // if (!itemId) {
//     //   setError(t('ItemRequired'));
//     //   return;
//     // }
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await ntxAPI.get<APIResponse<StockAging[]>>(`InventoryReports/GetStockAging`, {
//         params: {
//           ItemId: itemId,
//           InventoryId: inventoryId,
//           SubinventoryId: subInventoryId
//         }
//       });

//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : t('UnknownError'));
//       }
//     } catch (err) {
//       setError(err instanceof Error ? err.message : t('UnknownError'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setItemId(null);
//     setInventoryId(null);
//     setSubInventoryId(null);
//   };

//   const formatQuantity = (quantity: number): string => {
//     return new Intl.NumberFormat('en-US').format(quantity);
//   };

//   // Filter data based on zero balance toggle
//   // const filteredData = showZeroBalance ? data : data.filter(item => item.qty > 0);

//   // Get badge color based on aging bucket
//   const getBucketBadgeColor = (bucket: string) => {
//     switch (bucket) {
//       case '0-30 يوم':
//         return 'success';
//       case '31-60 يوم':
//         return 'info';
//       case '61-90 يوم':
//         return 'warning';
//       case 'أكثر من 90 يوم':
//         return 'danger';
//       default:
//         return 'secondary';
//     }
//   };

//   // Get progress bar variant based on aging bucket
//   const getProgressBarVariant = (bucket: string) => {
//     switch (bucket) {
//       case '0-30 يوم':
//         return 'success';
//       case '31-60 يوم':
//         return 'info';
//       case '61-90 يوم':
//         return 'warning';
//       case 'أكثر من 90 يوم':
//         return 'danger';
//       default:
//         return 'secondary';
//     }
//   };

//   // Calculate aging statistics
//   const calculateAgingStats = () => {
//     const totalQuantity = data.reduce((sum, item) => sum + item.qty, 0);
//     const bucketStats = data.reduce((acc, item) => {
//       if (!acc[item.bucket]) {
//         acc[item.bucket] = { quantity: 0, items: 0 };
//       }
//       acc[item.bucket].quantity += item.qty;
//       acc[item.bucket].items += 1;
//       return acc;
//     }, {} as Record<string, { quantity: number; items: number }>);

//     return { totalQuantity, bucketStats };
//   };

//   // Filter data based on zero quantity toggle
//   const filteredData = showZeroQuantity ? data : data.filter(item => item.qty > 0);

//   const { totalQuantity, bucketStats } = calculateAgingStats();

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>{i18n.language === 'en' ? 'Stock Balance Report' : 'تقرير رصيد المخزون'}</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>
//                 {i18n.language === 'en'
//                   ? `Showing: ${filteredData.length} of ${data.length} items`
//                   : `عرض: ${filteredData.length} من ${data.length} عنصر`}
//               </span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
//             </Alert>
//           )}

//           {data.length > 0 && (
//             <Card className='mb-4'>
//               <CardHeader>
//                 <h6 className='mb-0'>Aging Analysis Summary</h6>
//               </CardHeader>
//               <CardBody>
//                 <Row>
//                   <Col md={3}>
//                     <div className='text-center'>
//                       <h4 className='text-primary'>{formatQuantity(totalQuantity)}</h4>
//                       <p className='text-muted mb-0'>Total Quantity</p>
//                     </div>
//                   </Col>
//                   <Col md={9}>
//                     <div>
//                       {Object.entries(bucketStats).map(([bucket, stats]) => {
//                         const percentage = totalQuantity > 0 ? (stats.quantity / totalQuantity) * 100 : 0;
//                         return (
//                           <div key={bucket} className='mb-2'>
//                             <div className='d-flex justify-content-between mb-1'>
//                               <span>
//                                 <Badge bg={getBucketBadgeColor(bucket)} className='me-2'>
//                                   {bucket}
//                                 </Badge>
//                                 {stats.items} items
//                               </span>
//                               <span>
//                                 {formatQuantity(stats.quantity)} ({percentage.toFixed(1)}%)
//                               </span>
//                             </div>
//                             <ProgressBar
//                               variant={getProgressBarVariant(bucket)}
//                               now={percentage}
//                               style={{ height: '8px' }}
//                             />
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           )}

//           {/* Filters Section */}
//           <Card className='mb-4'>
//             <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
//             <Loading loading={loading1 || loading2 || loading3} error={error1 || error2 || error3}>
//               <CardBody>
//                 <Form>
//                   <Row className='g-3'>
//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('itemName')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable
//                           isClearable
//                           options={ItemsOptions}
//                           onChange={(option: any) => setItemId(option?.value || null)}
//                           value={ItemsOptions.find(f => f.value === itemId)}
//                           placeholder={t('Choose')}
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                           }}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('Inventory')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable={true}
//                           isClearable
//                           options={InventoryOptions}
//                           onChange={(option: any) => {
//                             setInventoryId(option === null ? null : option.value);
//                             setSubInventoryId(null);
//                           }}
//                           placeholder={t('Choose')}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('SubInventory')}</Form.Label>
//                         <TreeSelect
//                           loading={loading3}
//                           showSearch
//                           className='w-100'
//                           treeLine
//                           placeholder={t('Choose')}
//                           allowClear
//                           treeDefaultExpandAll={false}
//                           value={subInventoryId}
//                           onChange={(option: any) => {
//                             setSubInventoryId(option === null ? null : option);
//                           }}
//                           treeData={TreeSubInventoryData?.filter(f => f.parentId === inventoryId)}
//                           treeNodeFilterProp='title'
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group controlId='zeroBalanceFilter'>
//                         <Form.Label>
//                           {i18n.language === 'en' ? 'Show Zero Balance' : 'إظهار الأرصدة الصفرية'}
//                         </Form.Label>
//                         <Form.Check
//                           type='switch'
//                           checked={showZeroBalance}
//                           onChange={e => setShowZeroBalance(e.target.checked)}
//                           label={
//                             showZeroBalance
//                               ? i18n.language === 'en'
//                                 ? 'Showing all'
//                                 : 'إظهار الكل'
//                               : i18n.language === 'en'
//                               ? 'Hiding zero balance'
//                               : 'إخفاء الأرصدة الصفرية'
//                           }
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col xs={12} className='text-end'>
//                       <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                         {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
//                       </Button>
//                       <Button variant='primary' onClick={fetchData} disabled={loading}>
//                         {loading ? (
//                           <>
//                             <Spinner
//                               as='span'
//                               animation='border'
//                               size='sm'
//                               role='status'
//                               aria-hidden='true'
//                               className='me-2'
//                             />
//                             {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
//                           </>
//                         ) : i18n.language === 'en' ? (
//                           'Load Report'
//                         ) : (
//                           'تحميل التقرير'
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </CardBody>
//             </Loading>
//           </Card>

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading stock aging data...</p>
//             </div>
//           ) : filteredData.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Item Code</th>
//                     <th>Item Name</th>
//                     <th>Quantity</th>
//                     <th>Age (Days)</th>
//                     <th>Aging Bucket</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((item, index) => (
//                     <tr key={`${item.itemId}-${index}`}>
//                       <td>{item.itemCode}</td>
//                       <td>
//                         <div>{item.itemName}</div>
//                         {item.itemName2 && <div className='text-muted small'>{item.itemName2}</div>}
//                       </td>
//                       <td className='fw-bold'>{formatQuantity(item.qty)}</td>
//                       <td>
//                         <span className={item.ageInDays > 90 ? 'text-danger fw-bold' : ''}>{item.ageInDays} days</span>
//                       </td>
//                       <td>
//                         <Badge bg={getBucketBadgeColor(item.bucket)}>{item.bucket}</Badge>
//                       </td>
//                       <td>
//                         {item.ageInDays > 90 ? (
//                           <Badge bg='danger'>Slow Moving</Badge>
//                         ) : item.ageInDays > 60 ? (
//                           <Badge bg='warning'>Monitor</Badge>
//                         ) : (
//                           <Badge bg='success'>Fresh</Badge>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>
//             {i18n.language === 'en'
//               ? `Report generated on ${new Date().toLocaleString()}`
//               : `تم إنشاء التقرير في ${new Date().toLocaleString()}`}
//           </CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default StockAgingReport;

import React, { useState } from 'react';
import {
  Table,
  Spinner,
  Form,
  Row,
  Col,
  Button,
  Alert,
  Badge,
  CardFooter,
  CardTitle,
  ProgressBar
} from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, CardBody, CardHeader } from '@components/card/card';
import { ntxAPI } from '@API/axiosNeatex';
import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import type { APIResponse } from '@store/Shared/shared';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import { TreeSelect } from 'antd';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import Loading from '@components/Shared/Loader/Loading';

interface StockAging {
  itemId: string;
  itemCode: string;
  itemName: string;
  itemName2: string;
  qty: number;
  ageInDays: number;
  bucket: string;
}

const StockAgingReport: React.FC = () => {
  const [data, setData] = useState<StockAging[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
  const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
  const { t, i18n } = useTranslation();
  const [showZeroQuantity, setShowZeroQuantity] = useState<boolean>(false);

  // Filter states
  const [itemId, setItemId] = useState<string | null>(null);
  const [inventoryId, setInventoryId] = useState<string | null>(null);
  const [subInventoryId, setSubInventoryId] = useState<string | null>('');
  const [showZeroBalance, setShowZeroBalance] = useState<boolean>(false);

  const fetchData = async () => {
    // if (!itemId) {
    //   setError(t('ItemRequired'));
    //   return;
    // }
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<StockAging[]>>(`InventoryReports/GetStockAging`, {
        params: {
          ItemId: itemId,
          InventoryId: inventoryId,
          SubinventoryId: subInventoryId
        }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : t('UnknownError'));
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : t('UnknownError'));
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setItemId(null);
    setInventoryId(null);
    setSubInventoryId(null);
  };

  const formatQuantity = (quantity: number): string => {
    return new Intl.NumberFormat('en-US').format(quantity);
  };

  // Get badge color based on aging bucket
  const getBucketBadgeColor = (bucket: string) => {
    const bucketMap: { [key: string]: string } = {
      '0-30 يوم': 'success',
      '31-60 يوم': 'info',
      '61-90 يوم': 'warning',
      'أكثر من 90 يوم': 'danger',
      '0-30 days': 'success',
      '31-60 days': 'info',
      '61-90 days': 'warning',
      'Over 90 days': 'danger'
    };
    return bucketMap[bucket] || 'secondary';
  };

  // Get progress bar variant based on aging bucket
  const getProgressBarVariant = (bucket: string) => {
    const bucketMap: { [key: string]: string } = {
      '0-30 يوم': 'success',
      '31-60 يوم': 'info',
      '61-90 يوم': 'warning',
      'أكثر من 90 يوم': 'danger',
      '0-30 days': 'success',
      '31-60 days': 'info',
      '61-90 days': 'warning',
      'Over 90 days': 'danger'
    };
    return bucketMap[bucket] || 'secondary';
  };

  // Calculate aging statistics
  const calculateAgingStats = () => {
    const totalQuantity = data.reduce((sum, item) => sum + item.qty, 0);
    const bucketStats = data.reduce((acc, item) => {
      if (!acc[item.bucket]) {
        acc[item.bucket] = { quantity: 0, items: 0 };
      }
      acc[item.bucket].quantity += item.qty;
      acc[item.bucket].items += 1;
      return acc;
    }, {} as Record<string, { quantity: number; items: number }>);

    return { totalQuantity, bucketStats };
  };

  // Filter data based on zero quantity toggle
  const filteredData = showZeroQuantity ? data : data.filter(item => item.qty > 0);

  const { totalQuantity, bucketStats } = calculateAgingStats();

  // Text direction based on language

  // Translate bucket names
  const translateBucket = (bucket: string) => {
    if (i18n.language === 'en') {
      const bucketTranslations: { [key: string]: string } = {
        '0-30 يوم': '0-30 days',
        '31-60 يوم': '31-60 days',
        '61-90 يوم': '61-90 days',
        'أكثر من 90 يوم': 'Over 90 days'
      };
      return bucketTranslations[bucket] || bucket;
    }
    return bucket;
  };

  return (
    <div className='container mt-4'>
      <Card>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>{i18n.language === 'en' ? 'Inventory Aging Report' : 'تقرير أعمار المخزون'}</h5>
          {data.length > 0 && (
            <div>
              <span className='me-2'>
                {i18n.language === 'en'
                  ? `Showing: ${filteredData.length} of ${data.length} items`
                  : `عرض: ${filteredData.length} من ${data.length} عنصر`}
              </span>
            </div>
          )}
        </CardHeader>

        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
            </Alert>
          )}

          {/* Filters Section */}
          <Card className='mb-4'>
            <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
            <Loading loading={loading1 || loading2 || loading3} error={error1 || error2 || error3}>
              <CardBody>
                <Form>
                  <Row className='g-3'>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('itemName')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable
                          isClearable
                          options={ItemsOptions}
                          onChange={(option: any) => setItemId(option?.value || null)}
                          value={ItemsOptions.find(f => f.value === itemId)}
                          placeholder={t('Choose')}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('Inventory')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={InventoryOptions}
                          onChange={(option: any) => {
                            setInventoryId(option === null ? null : option.value);
                            setSubInventoryId(null);
                          }}
                          placeholder={t('Choose')}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('SubInventory')}</Form.Label>
                        <TreeSelect
                          loading={loading3}
                          showSearch
                          className='w-100'
                          treeLine
                          placeholder={t('Choose')}
                          allowClear
                          treeDefaultExpandAll={false}
                          value={subInventoryId}
                          onChange={(option: any) => {
                            setSubInventoryId(option === null ? null : option);
                          }}
                          treeData={TreeSubInventoryData?.filter(f => f.parentId === inventoryId)}
                          treeNodeFilterProp='title'
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group controlId='zeroBalanceFilter'>
                        <Form.Label>
                          {i18n.language === 'en' ? 'Show Zero Quantity' : 'إظهار الكميات الصفرية'}
                        </Form.Label>
                        <Form.Check
                          type='switch'
                          checked={showZeroQuantity}
                          onChange={e => setShowZeroQuantity(e.target.checked)}
                          label={
                            showZeroQuantity
                              ? i18n.language === 'en'
                                ? 'Showing all'
                                : 'إظهار الكل'
                              : i18n.language === 'en'
                              ? 'Hiding zero quantity'
                              : 'إخفاء الكميات الصفرية'
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} className={`text-end `}>
                      <Button variant='secondary' onClick={resetFilters} className='me-2'>
                        {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
                      </Button>
                      <Button variant='primary' onClick={fetchData} disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner
                              as='span'
                              animation='border'
                              size='sm'
                              role='status'
                              aria-hidden='true'
                              className='me-2'
                            />
                            {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                          </>
                        ) : i18n.language === 'en' ? (
                          'Load Report'
                        ) : (
                          'تحميل التقرير'
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Loading>
          </Card>

          {data.length > 0 && (
            <Card className='mb-4'>
              <CardHeader>
                <h6 className='mb-0'>{i18n.language === 'en' ? 'Aging Analysis Summary' : 'ملخص تحليل التقادم'}</h6>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={3}>
                    <div className='text-center'>
                      <h4 className='text-primary'>{formatQuantity(totalQuantity)}</h4>
                      <p className='text-muted mb-0'>{i18n.language === 'en' ? 'Total Quantity' : 'إجمالي الكمية'}</p>
                    </div>
                  </Col>
                  <Col md={9}>
                    <div>
                      {Object.entries(bucketStats).map(([bucket, stats]) => {
                        const percentage = totalQuantity > 0 ? (stats.quantity / totalQuantity) * 100 : 0;
                        const translatedBucket = translateBucket(bucket);
                        return (
                          <div key={bucket} className='mb-2'>
                            <div className='d-flex justify-content-between mb-1'>
                              <span>
                                <Badge bg={getBucketBadgeColor(bucket)} className='me-2'>
                                  {translatedBucket}
                                </Badge>
                                {stats.items} {i18n.language === 'en' ? 'items' : 'عنصر'}
                              </span>
                              <span>
                                {formatQuantity(stats.quantity)} ({percentage.toFixed(1)}%)
                              </span>
                            </div>
                            <ProgressBar
                              variant={getProgressBarVariant(bucket)}
                              now={percentage}
                              style={{ height: '8px' }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>{i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}</span>
              </Spinner>
              <p className='mt-2'>
                {i18n.language === 'en' ? 'Loading stock aging data...' : 'جاري تحميل بيانات تقادم المخزون...'}
              </p>
            </div>
          ) : filteredData.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{i18n.language === 'en' ? 'Item Code' : 'كود الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Item Name' : 'اسم الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Quantity' : 'الكمية'}</th>
                    <th>{i18n.language === 'en' ? 'Age (Days)' : 'العمر (أيام)'}</th>
                    <th>{i18n.language === 'en' ? 'Aging Bucket' : 'فترة التقادم'}</th>
                    <th>{i18n.language === 'en' ? 'Status' : 'الحالة'}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => (
                    <tr key={`${item.itemId}-${index}`}>
                      <td>{item.itemCode}</td>
                      <td>
                        <div>{i18n.language === 'en' ? item.itemName : item.itemName2 || item.itemName}</div>
                        {item.itemName2 && (
                          <div className='text-muted small'>
                            {i18n.language === 'en' ? item.itemName2 : item.itemName}
                          </div>
                        )}
                      </td>
                      <td className='fw-bold'>{formatQuantity(item.qty)}</td>
                      <td>
                        <span className={item.ageInDays > 90 ? 'text-danger fw-bold' : ''}>
                          {item.ageInDays} {i18n.language === 'en' ? 'days' : 'يوم'}
                        </span>
                      </td>
                      <td>
                        <Badge bg={getBucketBadgeColor(item.bucket)}>{translateBucket(item.bucket)}</Badge>
                      </td>
                      <td>
                        {item.ageInDays > 90 ? (
                          <Badge bg='danger'>{i18n.language === 'en' ? 'Slow Moving' : 'بطيء الحركة'}</Badge>
                        ) : item.ageInDays > 60 ? (
                          <Badge bg='warning'>{i18n.language === 'en' ? 'Monitor' : 'يتطلب مراقبة'}</Badge>
                        ) : (
                          <Badge bg='success'>{i18n.language === 'en' ? 'Fresh' : 'طازج'}</Badge>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>
                {i18n.language === 'en'
                  ? 'No data available. Set your filters and click "Load Report" to generate.'
                  : 'لا توجد بيانات متاحة. قم بتعيين الفلاتر الخاصة بك وانقر على "تحميل التقرير" لإنشائه.'}
              </p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>
            {i18n.language === 'en'
              ? `Report generated on ${new Date().toLocaleString()}`
              : `تم إنشاء التقرير في ${new Date().toLocaleString('ar-EG')}`}
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default StockAgingReport;
